// John Eldhose 20180523
import React, { Component } from 'react';
import { Button, CircularProgress, Grid, Typography } from '@material-ui/core';
import { CreditCard } from '@material-ui/icons';
import { uploadFile } from '../../Api/uploadFile';
import { taxRate } from '../../Api/taxRate';
import { checkout } from '../../Api/checkout';

class Checkout extends Component {

  state = {
    subtotal: 0,
    shipping: -1,
    taxExemption: '',
    taxRate: -1,
    ccClicked: false,
    ccStatus: ''
  }
  componentWillMount() {
    taxRate({address: this.props.address, checkout: this.props.checkout})
      .then((tax) => {
        if(tax['status'] === 'true' && this.state.taxExemption === '')
          this.setState({ taxRate: tax['rate'] });
      })
      .catch((error) => { console.log(error); });
    var subtotal = 0, shipping = 0;
    for(var i = 0; i < this.props.checkout.length; i++)
      subtotal += this.props.checkout[i].price * this.props.checkout[i].quantity;
    this.setState({ subtotal: subtotal, shipping: shipping });
  }
  componentDidMount() {
    const tmpid = (this.props.profile['email'] === 'jeldhose@carlsonsw.com') ? ['4y43W836Zqw', '82ndJFTrKGvNcDQ2fH68PR6QxjB2KC2XJhaFYFM8Q66jMv254bk4994wN9nrQjXq', 'https://jstest.authorize.net/v3/AcceptUI.js'] : ['7UL3sa5s', '273VgNhju8L7S8s2WXcUCNeRH9HGKpBCD6rtWbR5R77Zf9uQs5TceX6b9p4CdfVh', 'https://js.authorize.net/v3/AcceptUI.js'];
    var i, script, accb = [
      {key: 'data-billingAddressOptions', val: '{"show":true,"required":true}'},
      {key: 'data-apiLoginID', val: tmpid[0]},
      {key: 'data-clientKey', val: tmpid[1]},
      {key: 'data-acceptUIFormBtnTxt', val: 'Charge Card'},
      {key: 'data-acceptUIFormHeaderTxt', val: 'Card Information'},
      {key: 'data-paymentOptions', val: '{"showCreditCard":true,"showBankAccount":false}'},
      {key: 'data-responseHandler', val: 'responseHandler'}
    ], ascr1 = [
      {key: 'type', val: 'text/javascript'},
      {key: 'charset', val: 'utf-8'},
      {key: 'src', val: tmpid[2]}
    ];
    var ccb = document.getElementById('ccButton');
    for(i = 0; i < accb.length; i++)
      ccb.setAttribute(accb[i].key, accb[i].val);
    script = document.createElement('script');
    for(i = 0; i < ascr1.length; i++)
      script[ascr1[i].key] = ascr1[i].val;
    document.body.appendChild(script);
    window.ccResponse = (res) => {
      this.setState({ ccClicked: true });
      this.handleCheckout(res);
    }
    script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = 'responseHandler = (res) => {window.ccResponse(res);}'
    document.body.appendChild(script);
  }
  handleExemption = (e) => {
    this.setState({ taxExemption: 'Uploading . . .' });
    uploadFile('taxExemption', e.target.files[0])
      .then((uf) => {
        if(uf.status === 'true')
          this.setState({ taxExemption: 'Uploaded', taxRate: 0 });
        else
          this.setState({ taxExemption: 'Upload failed' });
      })
      .catch((error) => { console.log(error); });
  }
  taxExemption = (te) => {
    if(te === '')
      return (
        <td colSpan='2' align='right'>
          <input
            color='primary'
            type='file'
            accept='application/pdf'
            id='icon-button-file'
            style={{ display: 'none', }}
            onChange={this.handleExemption}
          />
          <label htmlFor='icon-button-file'>
            <Button
              variant='flat'
              component='span'
              size='small'
            >
              <Typography variant='caption'>
                Upload Sales Tax Exemption Certificate
              </Typography>
            </Button>
          </label>
        </td>
      );
    else
      return (
        <td colSpan='2' align='right'>
          <Typography variant='caption'>{te}</Typography>
        </td>
      );
  }
  tax = () => {
    const tax = (this.state.subtotal + this.state.shipping) * this.state.taxRate;
    return (tax < 0) ? 0 : tax;
  }
  total = () => {
    const total = this.state.subtotal + this.state.shipping + this.tax();
    return total;
  }
  handleCheckout = (res) => {
    window.ccResponse = (res) => {};
    checkout({
      plan: ((typeof this.props.plan === 'undefined') ? '' : this.props.plan),
      profile: this.props.profile,
      address: this.props.address,
      baddress: this.props.baddress,
      summary: {subtotal: this.state.subtotal, shipping: this.state.shipping, taxRate: this.state.taxRate, tax: this.tax(), total: this.total()},
      checkout: this.props.checkout,
      response: res
    })
      .then((co) => {
        if(co.message !== '')
          this.setState({ ccStatus: co.message });
        else if(co.status !== 'true')
          this.setState({
            ccStatus: 'Processing failed. Please report to the contact below'
          });
        if(co.status === 'true')
          this.props.completed();
      })
      .catch((error) => { console.log(error); });
  }

  render() {
    if(this.state.ccClicked) {
      if(this.state.ccStatus === '')
        return <CircularProgress style={{ padding: '80px 0px' }} />;
      else
        return (
          <Typography variant='subheading' style={{ padding: '100px 30px' }}>
            {this.state.ccStatus}
          </Typography>
        );
    }
    else {
      return (
        <div>
          <Typography variant='display1'>
            <center><font color='#385687'>Verify & Payment</font></center>
          </Typography>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8} className='ShoppingCart'>
              <table width='100%' className='ShoppingCartRow'>
                <tbody>
                  {this.props.checkout.map((item) => {
                    return (
                      <tr key={item.name} className='ShoppingCartRow'>
                        <td>
                          <Typography variant='body2'>
                            <b>{item.name}</b>
                          </Typography>
                          <Typography variant='body1'>
                            {item.description}
                          </Typography>
                        </td>
                        <td align='right'>
                          <Typography variant='body1'>
                            {item.quantity}
                          </Typography>
                        </td>
                        <td align='right'>
                          <Typography variant='body1'>
                            {(item.price * item.quantity).toLocaleString('en-US', {
                              style: 'currency', currency: 'USD'
                            })}
                          </Typography>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <div className='ShoppingCartTotal'>
                <table width='100%'>
                  <tbody>
                    <tr>
                      <td>
                        <Typography variant='body1'>Subtotal</Typography>
                      </td>
                      <td align='right'>
                        <Typography variant='body1'>
                          {this.state.subtotal.toLocaleString('en-US', {
                            style: 'currency', currency: 'USD'
                          })}
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Typography variant='body1'>Shipping</Typography>
                      </td>
                      <td align='right'>
                        <Typography variant='body1'>
                          {this.state.shipping.toLocaleString('en-US', {
                            style: 'currency', currency: 'USD'
                          })}
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Typography variant='body1'>
                          Sales Tax (GST or VAT)
                        </Typography>
                      </td>
                      <td align='right'>
                        <Typography variant='body1'>
                          {this.tax().toLocaleString('en-US', {
                            style: 'currency', currency: 'USD'
                          })}
                        </Typography>
                      </td>
                    </tr>
                    <tr>{this.taxExemption(this.state.taxExemption)}</tr>
                    <tr>
                      <td>
                        <Typography variant='title'>Total</Typography>
                      </td>
                      <td align='right'>
                        <Typography variant='title'>
                          <font color='SteelBlue'>
                            {this.total().toLocaleString('en-US', {
                              style: 'currency', currency: 'USD'
                            })}
                          </font>
                        </Typography>
                      </td>
                    </tr>
                    <tr><td colSpan='2'>&nbsp;</td></tr>
                    <tr>
                      <td colSpan='2' align='center'>
                        <Button
                          id='ccButton'
                          className='AcceptUI'
                          variant='raised'
                          color='primary'
                          disabled={(
                            this.state.subtotal <= 0 ||
                            this.state.shipping < 0 ||
                            this.state.taxRate < 0 ||
                            this.state.ccClicked
                          )}
                        >
                          <CreditCard /> &nbsp; Payment
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <Typography variant='caption'>
                  <font size='1' style={{ fontStyle: 'italic' }}>
                    All pricing shown in United States Dollar (USD)
                    {(this.props.profile['email'] === 'jeldhose@carlsonsw.com') ? ' test' : ''}
                  </font>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      );
    }
  }
}

export default Checkout;



// WEBPACK FOOTER //
// ./src/components/lib/Checkout.js